import React from "react";
import { Award, ShoppingBag, Factory } from "lucide-react";
import Counter from "../Counter";

const StatsBand = () => (
  <section className="bg-[#0F1245] text-white">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-14 md:py-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        <div data-testid="band-stat-years" className="bg-[#0F1245] p-8 md:p-10 text-center">
          <Award size={22} strokeWidth={1.4} className="text-[#B7E4F4] mx-auto" />
          <div className="font-serif-display text-5xl md:text-6xl mt-4">
            <Counter to={18} suffix="+" duration={1800} />
          </div>
          <div className="overline mt-3" style={{ color: "#B7E4F4" }}>Years Experience</div>
        </div>
        <div data-testid="band-stat-retailers" className="bg-[#0F1245] p-8 md:p-10 text-center">
          <ShoppingBag size={22} strokeWidth={1.4} className="text-[#B7E4F4] mx-auto" />
          <div className="font-serif-display text-5xl md:text-6xl mt-4">
            <Counter to={20000} suffix="+" duration={2200} />
          </div>
          <div className="overline mt-3" style={{ color: "#B7E4F4" }}>Retailers Served</div>
        </div>
        <div data-testid="band-stat-mw" className="bg-[#0F1245] p-8 md:p-10 text-center">
          <Factory size={22} strokeWidth={1.4} className="text-[#B7E4F4] mx-auto" />
          <div className="font-serif-display text-3xl md:text-4xl mt-4 leading-tight">Manufacturer<br />&amp; Wholesaler</div>
          <div className="overline mt-3" style={{ color: "#B7E4F4" }}>End-to-End In-House</div>
        </div>
      </div>
    </div>
  </section>
);

export default StatsBand;
